document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.header-bottom-offer-icon');
  const drawer = document.querySelector('.offer-drawer');
  const overlay = document.querySelector('.offer-drawer-overlay');
  const closeBtns = document.querySelectorAll(
    '.offer-drawer__close, .offer-drawer__back'
  );

  if (trigger) {
    trigger.addEventListener('click', () => {
      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('overflow-hidden');
    });
  }

  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeDrawer);
  });

  overlay?.addEventListener('click', closeDrawer);

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  document.querySelectorAll('.offer-copy-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      navigator.clipboard.writeText(btn.dataset.code);

      const original = btn.innerText;
      btn.innerText = 'Copied';

      setTimeout(() => {
        btn.innerText = original;
      }, 1500);
    });
  });

  document.querySelectorAll('[data-end-date]').forEach(item => {
    const endDate = item.dataset.endDate;

    if (!endDate) return;

    const today = new Date();
    const end = new Date(endDate);

    const diff = Math.ceil(
      (end - today) / (1000 * 60 * 60 * 24)
    );

    if (diff <= 0) {
      item.textContent = 'TODAY';
    } else if (diff === 1) {
      item.textContent = '1 DAY LEFT';
    } else if (diff <= 7) {
      item.textContent = `${diff} DAYS LEFT`;
    } else {
      item.textContent = 'THIS WEEK';
    }
  });
});